(function () {
	var fixedHeader = document.querySelector('.js-header');
	var links = document.querySelectorAll('[data-scroll-smooth]');

	if (fixedHeader && links.length) {
		var smoothScroll = function (top) {
			var scrollTop = top - fixedHeader.offsetHeight;
			
			window.scrollTo({
				top: scrollTop,
				behavior: "smooth"
			});
		};

		Array.prototype.forEach.call(links, function (node) {
			node.addEventListener('click', function (e) {
				e.preventDefault();
				// console.log('clicked');
				var target = this.getAttribute('data-hash') ? this.getAttribute('data-hash') : this.getAttribute('href');
				var ofssetTop = document.querySelector(target).offsetTop;
				smoothScroll(ofssetTop);
			});
		});
	}
})();